var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"grid"},[_c('h2',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.$t("navBar.ourBlogs")))]),(_vm.blogs)?_c('ul',{staticClass:"row garden-row-none-padding"},_vm._l((_vm.blogs),function(blog,index){return _c('li',{key:index,staticClass:"col-md-4 col-sm-12"},[_c('div',{staticClass:"garden-img-full-width"},[_c('router-link',{attrs:{"to":{
            name: 'SinglePost',
            params: {
              type: 'blog',
              slug: ("" + (blog.slug))
            }
          }}},[_c('img',{attrs:{"src":blog.featuredImage,"alt":blog.title}})])],1),_c('div',{staticClass:"box"},[_c('div',{staticClass:"box-content"},[_c('h3',{staticClass:"title"},[_c('router-link',{attrs:{"to":{
                name: 'SinglePost',
                params: {
                  type: 'blog',
                  slug: ("" + (blog.slug))
                }
              }}},[_vm._v(_vm._s(blog.title.substring(0, 70))+"....")])],1),_c('p',{staticClass:"text-justify"},[_vm._v(" "+_vm._s(_vm._f("strippedContent")(_vm.decodeHtml(blog.content)))+" "+_vm._s("...")),_c('router-link',{staticClass:"readMore",attrs:{"to":{
                name: 'SinglePost',
                params: {
                  type: 'blog',
                  slug: ("" + (blog.slug))
                }
              }}},[_vm._v(" "+_vm._s(_vm.$t("readMore"))+_vm._s(" ")+" ")])],1)])])])}),0):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }